/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MenuItem/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function MenuItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Tabs/Content/Content/MenuItem"
  
}) {
let menuItemIdValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let menuItemTextValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'text',
})
let myTasksCountValueData = fromData.useDataValue({ viewPath,
context: 'my_tasks_count',
})
let aggregateData = fromHelpers.tabTitle(menuItemIdValueData, menuItemTextValueData, myTasksCountValueData)
let selectedSubmenuTabIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'submenu_tab_id',
})
let menuItemIdValueData1 = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let aggregateData1 = fromAggregate.equals(selectedSubmenuTabIdValueData, menuItemIdValueData1)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 data="menu_item.id"
 data="menu_item.text"
 data="my_tasks_count"
 aggregate="helpers.js tabTitle"
 text={aggregateData}
 onClick={onClick}
 data="selected.submenu_tab_id"
 data="menu_item.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
{children}
</React.Fragment>)
}